import { render, staticRenderFns } from "./navigate.vue?vue&type=template&id=6fa23191"
import script from "./navigate.vue?vue&type=script&lang=js"
export * from "./navigate.vue?vue&type=script&lang=js"
import style0 from "./navigate.vue?vue&type=style&index=0&id=6fa23191&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports